import _ from 'lodash';
class Menus {
    constructor() {
        this.menusO = {};
    }
    registerMenu(menu) {
        if (this.menusO[menu.name]) {
            return;
        }
        this.menusO[menu.name] = _.cloneDeep(menu);
    }
    registerMenus(menus) {
        menus.forEach((menu) => {
            this.registerMenu(menu);
        });
    }
    getMenus() {
        const menus = [];
        const menusO = _.cloneDeep(this.menusO);
        Object.keys(this.menusO).forEach((menuName) => {
            const menu = menusO[menuName];
            if (!menu.parentName) {
                menus.push(menu);
            }
            else {
                const parent = menusO[menu.parentName];
                if (!parent.children) {
                    parent.children = [];
                }
                parent.children.push(menu);
            }
        });
        return _.sortBy(menus, ['order']);
    }
}
export default Menus;
